module.exports = __webpack_public_path__ + "fonts/SalesforceSans-Bold.68a71533d08ff9251d6f179043a4781b.woff2";